<template>
    <a-modal :visible="isShow" title="取消订单" ok-text="确认" cancel-text="取消" @ok="ok" @cancel="cancel">
        <a-form-model labelAlign="left" :model="params" :rules="rules" ref="cancelForm">
            <a-form-model-item label="选择取消原因" prop="des">
                <a-radio-group v-model="params.des" :options="reasonOptions" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
export default {
    name: 'CancelOrderModal',
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
            type: Boolean,
        },
        id: {
            type: String | Number,
        },
    },
    data () {
        return {
        params: {
            des: '',//取消原因
        },
        reasonOptions: [
            {
                label: '改买其它商品',
                value: '改买其它商品'
            },
            {
                label: '改用其它配送方式',
                value: '改用其它配送方式'
            },
            {
                label: '从其他店铺购买',
                value: '从其他店铺购买'
            },
            {
                label: '其它原因',
                value: '其它原因'
            }
        ],
        rules: {
            des: [
                { required: true, message: '请选择一个取消原因', trigger: ['blur','change'] },
            ]
        }
        }
    },
    methods: {
        ok () {
            this.$refs.cancelForm.validate(status => {
                if (!status) return

                var _this = this;

                _this.$util.api('/order/cancel',{
                    id: _this.id,
                    des: _this.params.des
                },function(res){
                    // _this.$message[res.code == 10000 ? 'success' : 'error'](res.msg);

                    if(res.code == 10000){
                        _this.cancel();
                        _this.$emit('cancel');
                        _this.$message.success('取消成功')
                    }else{
                        _this.$message.error('取消失败')
                    }
                });
            })
        },
        cancel () {
            this.$emit('hidden', false)
        }
    },
}
</script>
<style scoped>
::v-deep .ant-form-item-label {
    line-height: unset;
}
::v-deep .ant-radio-group {
    display: flex;
    flex-direction: column;
}

::v-deep .ant-radio-wrapper:nth-child(n + 2) {
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/deal/orders/CancelOrderModal.vue